import { render, staticRenderFns } from "./message-call-c2c.vue?vue&type=template&id=ca975ce8&scoped=true"
import script from "./message-call-c2c.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-call-c2c.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-call-c2c.vue?vue&type=style&index=0&id=ca975ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca975ce8",
  null
  
)

export default component.exports